import aws from './aws';
export const useGQL = (entity) => {
  /**
   * extract data from query/mutation result
   * @param {*} response
   */
  const extractData = (response, isMultiple = false) => {
    try {
      const data = response.data;
      if (isMultiple) return data;
      const key = Object.keys(data)[0];
      return data[key];
    } catch (e) {
      console.error(e);
      throw new Error(response.errors || e);
    }
  };

  /**
   * send mutation to SDM backend
   * @param {*} type
   * @param {*} mutation
   * @param {*} input
   */
  const sendMutation = async (
    type,
    mutation,
    input,
    limitless = false,
    isMultiple = false
  ) => {
    return new Promise((resolve, reject) => {
      aws.API.post(mutation, input, limitless)
        .then((response) => {
          resolve(extractData(response, isMultiple));
        })
        .catch((e) => {
          console.error(`${type}-${entity}`, e);
          reject();
        })
        .finally(() => {
          //useLoader && hideLoader()
        });
    });
  };

  /**
   *
   * @param {*} queryName
   * @param {*} querySchema
   * @param {*} variables
   */
  const sendQuery = (
    queryName,
    querySchema,
    variables,
    limitless = false,
    isMultiple = false
  ) => sendMutation(queryName, querySchema, variables, limitless, isMultiple);

  const getQuery = (id, schema, email) => {
    const _entity = `${entity[0].toUpperCase()}${entity.slice(1)}`;
    const query = `
        query get${_entity}(
            $id: ID!           
        ) {
            get${_entity}(id: $id) {
                ${schema}
            }
        }
    `;
    return sendQuery('get', query, { id: id }, email);
  };

  const createMutation = (input, schema) => {
    const _entity = `${entity[0].toUpperCase()}${entity.slice(1)}`;
    const mutation = `
        mutation create${_entity}(
            $input: Create${_entity}Input!
            $condition: Model${_entity}ConditionInput
        ) {
            create${_entity}(input: $input, condition: $condition) {
                ${schema || 'id'}
            }
        }
    `;
    return sendMutation('create', mutation, { input: { ...input } });
  };

  const createMultipleMutation = (inputList, schema) => {
    const _entity = `${entity[0].toUpperCase()}${entity.slice(1)}`;
    const mutation = `
        mutation create${_entity}(
          ${inputList.map((_, idx) => {
            return `$input${idx}: Create${_entity}Input!`;
          })}
          $condition: Model${_entity}ConditionInput
          ) {     
            ${inputList.map((_, idx) => {
              return `create${idx}: create${_entity}(input: $input${idx}, condition: $condition) {
                  ${schema || 'id'}
              }`;
            })}
        }
    `;

    const variables = {};
    inputList.map((input, idx) => {
      variables[`input${idx}`] = input;
    });

    return sendMutation('create', mutation, { ...variables }, false, true);
  };

  const updateMutation = (input) => {
    const _entity = `${entity[0].toUpperCase()}${entity.slice(1)}`;
    const mutation = `
        mutation update${_entity}(
            $input: Update${_entity}Input!
            $condition: Model${_entity}ConditionInput
        ) {
            update${_entity}(input: $input, condition: $condition) {
                id
            }
        }
    `;
    return sendMutation('update', mutation, { input: { ...input } });
  };

  const updateMultipleMutation = (inputList, schema) => {
    const _entity = `${entity[0].toUpperCase()}${entity.slice(1)}`;
    const mutation = `
        mutation update${_entity}(
          ${inputList.map((_, idx) => {
            return `$input${idx}: Update${_entity}Input!`;
          })}
          $condition: Model${_entity}ConditionInput
          ) {     
            ${inputList.map((_, idx) => {
              return `update${idx}: update${_entity}(input: $input${idx}, condition: $condition) {
                  ${schema || 'id'}
              }`;
            })}
        }
    `;

    const variables = {};
    inputList.map((input, idx) => {
      variables[`input${idx}`] = input;
    });

    return sendMutation('update', mutation, { ...variables }, false, true);
  };

  const deleteMutation = (input) => {
    const _entity = `${entity[0].toUpperCase()}${entity.slice(1)}`;
    const mutation = `
        mutation delete${_entity}(
            $input: Delete${_entity}Input!
            $condition: Model${_entity}ConditionInput
        ) {
            delete${_entity}(input: $input, condition: $condition) {
                id
            }
        }
    `;
    return sendMutation('delete', mutation, { input: { ...input } });
  };

  const deleteMultipleMutation = (inputList) => {
    const _entity = `${entity[0].toUpperCase()}${entity.slice(1)}`;
    const mutation = `
        mutation delete${_entity}(
          ${inputList.map((_, idx) => {
            return `$input${idx}: Delete${_entity}Input!`;
          })}
          $condition: Model${_entity}ConditionInput
          ) {     
            ${inputList.map((_, idx) => {
              return `delete${idx}: delete${_entity}(input: $input${idx}, condition: $condition) {
                  id
              }`;
            })}
        }
    `;

    const variables = {};
    inputList.map((input, idx) => {
      variables[`input${idx}`] = input;
    });

    return sendMutation('delete', mutation, { ...variables }, false, true);
  };

  const getGraphqlDynamicFilter = (config) => {
    const filters = [];
    config.customParamsFilter?.map((paramFilter) => {
      filters.push(`
          ${paramFilter.paramKey}: { ${paramFilter.expression || 'eq'}: "${
        paramFilter.value
      }"}
        `);
    });
    const orFilter = config.orFilter
      ? `or: [
      ${config.orFilter.arrayOfElem
        .map((elem) => {
          return `{${config.orFilter.paramKey || 'id'}: { ${
            config.orFilter.expression || 'eq'
          }: "${elem}"}}`;
        })
        .join(',')}        
    ]`
      : null;
    if (orFilter) {
      filters.push(orFilter);
    }
    const filterStr = `
    filter: { 
      ${filters.join(',')}      
    }`;
    if (filterStr.length >= 10013)
      throw new Error(
        `exceeded maximum filter characters ${filterStr.length} > 10013 max characters`
      );
    return filterStr;
  };

  return {
    getQuery,
    createMutation,
    createMultipleMutation,
    updateMutation,
    updateMultipleMutation,
    deleteMutation,
    deleteMultipleMutation,
    extractData,
    sendQuery,
    getGraphqlDynamicFilter,
  };
};
